const createABtranslationKeys = (experiments, translations) => {
    const abExperiments = {};
    for (const [expKey, experimentValue] of Object.entries(experiments)) {
        const isAbTest = /specs\.abTranslate\.(.*?)\.(.*)$/.exec(expKey);
        if (isAbTest) {
            const translationDetails = isAbTest[2];
            const [translationKey, specName] = translationDetails.split('abSpec-');
            let translationKeys;
            if (specName) {
                translationKeys = Array.from(new Set(Object.keys(translations)
                    .filter((key) => key.includes(specName))
                    .map((key) => key.split('|abTranslate')[0])));
            }
            else {
                translationKeys = [translationKey];
            }
            translationKeys.forEach((key) => {
                if (experimentValue !== '0') {
                    const specSuffix = specName ? `|${specName}` : ``;
                    abExperiments[key] = `${key}|abTranslate_${experimentValue}${specSuffix}`;
                }
                else {
                    abExperiments[key] = key;
                }
            });
        }
    }
    return abExperiments;
};
export const abTranslate = (experiments, translations) => {
    const abTranslationKeys = createABtranslationKeys(experiments, translations);
    const updatedTranslations = { ...translations };
    // replace existing translation keys with abTest results
    for (const [translationKey, translationValue] of Object.entries(abTranslationKeys)) {
        const translationHasExperiment = Object.prototype.hasOwnProperty.call(abTranslationKeys, translationKey);
        const abTranslationKey = translations[translationValue];
        if (translationHasExperiment && abTranslationKey) {
            updatedTranslations[translationKey] = abTranslationKey;
        }
    }
    return updatedTranslations;
};
//# sourceMappingURL=abTranslate-runtime.js.map